<nav class="navbar navbar-expand-lg fixed-top nav-section">
    <div class="container">
        <a class="navbar-brand" routerLink="/parking-rate"><img src="assets/images/logo-southbay.svg" class="logo"
                alt="AC Hotel by Marriott Airport Parking Application"></a>
        <a class="ml-auto mr-1"></a>
        <!-- <button class="btn btn-success ml-auto mr-1">Always open</button> -->

        <button class="navbar-toggler" type="button" data-toggle="collapse"
            (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed">
            <span class="navbar-toggler-icon"><i class="ri-menu-3-line"></i></span>
        </button>
        <div class="collapse navbar-collapse flex-grow-0" id="navbarSupportedContent" [ngbCollapse]="!isCollapsed">
            <ul class="navbar-nav text-right">
                <li class="nav-item " routerLinkActive="active">
                    <a class="nav-link" routerLink="/reservations-detail"><i class="fa fa-user"></i>Reservations </a>
                </li>
                <li class="nav-item " routerLinkActive="active">
                    <a class="nav-link" routerLink="/parking-rate"><i class="fa fa-user"></i>Rates </a>
                </li>
                <li class="nav-item dropdown" routerLinkActive="active">
                    <a class="nav-link dropdown-toggle" href="#" id="navbardrop" data-toggle="dropdown">
                        Shuttle
                    </a>
                    <div class="dropdown-menu">
                        
                        <a class="dropdown-item" (click)="isCollapsed = !isCollapsed" routerLink="/shuttle-rate"
                            routerLinkActive="active">Shuttle Rate</a>
                        <a class="dropdown-item" (click)="isCollapsed = !isCollapsed" routerLink="/shuttle-report"
                            routerLinkActive="active">Shuttle Reports</a>
                    </div>
                </li>
                
                <li class="nav-item dropdown" routerLinkActive="active">
                    <a class="nav-link dropdown-toggle" href="#" id="navbardrop" data-toggle="dropdown">
                        Reports
                    </a>
                    <div class="dropdown-menu">
                        <a class="dropdown-item" (click)="isCollapsed = !isCollapsed" routerLink="/revenue-report"
                            routerLinkActive="active">Revenue Reports</a>
                    </div>
                </li>
                <li class="nav-item dropdown" routerLinkActive="active">
                    <a class="nav-link dropdown-toggle" href="#" id="navbardrop" data-toggle="dropdown">
                        Profile
                    </a>
                    <div class="dropdown-menu">
                        <a class="dropdown-item" (click)="isCollapsed = !isCollapsed" routerLink="/admin-profile"
                            routerLinkActive="active">View Profile</a>
                        <a class="dropdown-item" (click)="isCollapsed = !isCollapsed"
                            routerLink="/admin-change-password" routerLinkActive="active">Change Password</a>
                    </div>
                </li>
                <li class="nav-item dropdown" routerLinkActive="active" *ngIf="me.role_id == 1">
                    <a class="nav-link dropdown-toggle" href="#" id="navbardrop" data-toggle="dropdown">
                        Settings
                    </a>
                    <div class="dropdown-menu">
                        <a class="dropdown-item" (click)="isCollapsed = !isCollapsed" routerLink="/user-list"
                            routerLinkActive="active">user</a>
                        <a class="dropdown-item" (click)="isCollapsed = !isCollapsed" routerLink="/property-list"
                            routerLinkActive="active">Property</a>
                        <a class="dropdown-item" (click)="isCollapsed = !isCollapsed" routerLink="/role-list"
                            routerLinkActive="active">Role</a>
                        <a class="dropdown-item" (click)="isCollapsed = !isCollapsed" routerLink="/menu-list"
                            routerLinkActive="active">Menu</a>
                        <a class="dropdown-item" (click)="isCollapsed = !isCollapsed" routerLink="/module-list"
                            routerLinkActive="active">Module</a>
                        <a class="dropdown-item" (click)="isCollapsed = !isCollapsed" routerLink="/permission-list"
                            routerLinkActive="active" (click)="isCollapsed = !isCollapsed">Permission</a>
                        <a class="dropdown-item" (click)="isCollapsed = !isCollapsed" routerLink="/package-list"
                            routerLinkActive="active" (click)="isCollapsed = !isCollapsed">Package</a>
                        <!-- <a class="dropdown-item" (click)="isCollapsed = !isCollapsed"
                            routerLink="/change-password">Change Password</a> -->
                    </div>
                </li>
                <!--  <li class="nav-item">
                    <a class="nav-link" href="#">Maps</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#">Reviews</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#">Contact</a>
                </li> -->
                <li class="nav-item nav-special">
                    <a class="nav-link" (click)="logout()"><span>Logout</span></a>
                </li>
            </ul>
        </div>
    </div>
</nav>

<section class="section-breadcumb">
    <div class="container">
        <div class="row">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a routerLink="/parking-rate">Home</a></li>
                        <li class="breadcrumb-item active" aria-current="page" *ngFor='let breadcrumb of breadcrumbs'>

                            <a [routerLink]="[breadcrumb.url]" routerLinkActive="active"
                                *ngIf="breadcrumb.url">{{ breadcrumb.label }}</a>
                            <a *ngIf="!breadcrumb.url && breadcrumb.label ">{{ breadcrumb.label }}</a>

                        </li>
                    </ol>
                </nav>
            </div>
        </div>
    </div>
</section>

<router-outlet></router-outlet>
<footer class="footer">
    <div class="container">
        <div class="row">
            <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 footer-sec">
                <p>&copy; {{Year}} AC HOTELS BY MARRIOTT. ALL RIGHTS RESERVED</p>
                <ul class="navbar">
                    <li><a routerLink="/about" routerLinkActive="active" class="nav-item">About</a></li>
                    <li><a routerLink="/contact" routerLinkActive="active" class="nav-item">Contact</a></li>
                    <li><a routerLink="/terms-privacy" routerLinkActive="active" class="nav-item">Terms & Privacy</a>
                    </li>
                </ul>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 payment-sec">

                <ul class="navbar">
                    <li><img src="assets/images/paypal/paypal.png" alt="Paypal"></li>
                    <li><img src="assets/images/paypal/mastercard.png" alt="Mastercard"></li>
                    <li><img src="assets/images/paypal/visa.png" alt="visa"></li>
                    <li><img src="assets/images/paypal/americanexpress.png" alt="Americal Express"></li>
                    <li><img src="assets/images/paypal/discover.png" alt="Discover card"></li>
                    <li>
                        <img src="assets/images/paypal/siteseal_gd_3_h_d_m.gif" alt="godaddy verified and secured">
                    </li>
                </ul>

            </div>
        </div>
    </div>
</footer>
